import { api, responseErrorCheck, TmrBaseResource } from 'stylewhere/api'
import { __, T } from 'stylewhere/shared/i18n'

export class UserManuals extends TmrBaseResource {
  static endpoint = 'api/v1/userManuals'

  private static async fetchUserManual(type: 'STATION' | 'OPERATION', operationId?: string) {
    const res = await api.get(this.endpoint, { type, operationId }, { responseType: 'blob' })
    return responseErrorCheck(res)
  }

  static async openManualPdf(operationId?: string) {
    const newTab = window.open('about:blank', '_blank')
    const doc = newTab.document
    Object.assign(doc.body.style, {
      display: 'flex',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'sans-serif',
      margin: 0
    })

    const loadingText = doc.createElement('h2')
    loadingText.textContent = __(T.misc.pleaseWait)
    doc.body.appendChild(loadingText)

    try {
      const pdf = await UserManuals.fetchUserManual(operationId ? 'OPERATION' : 'STATION', operationId)
      const url = URL.createObjectURL(pdf)
      newTab.location.href = url
    } catch (err: any) {
      console.error(err)
      loadingText.textContent = err.message
      loadingText.style.color = 'red'
      console.error(err)
    }
  }
}
